import { DefaultOptions } from '@tanstack/react-query'

export const DEFAULT_QUERY_CLIENT_OPTIONS: DefaultOptions = {
  queries: {
    gcTime: 1000 * 60 * 60 * 24 // 24 hours
  }
}
